if($('.day-time-select-wrap').length) {
	$(function(){
		// 予約可能時間
		// ▼予約可能時間をチェックした時
		// チェックした曜日の予約可能時間を表示/非表示
		$(document).on('change', "input[type='checkbox'][name^='flg_able_']", function () {
			var week = $(this).attr('name');
			if( $(this).prop('checked')){
				$('#week-' + week).css('display', 'flex');
				$('#week-' + week + ' .js-select-wrap .js-select2').prop("required", true);
			}else{
				$('#week-' + week).css('display', 'none');
				$('#week-' + week + ' .js-select-wrap .js-select2').removeAttr("required");
			}
			// チェック数0の時み見出し非表示
			if($("input[type='checkbox'][name^='flg_able_']:checked").length) {
					$('.js-reserve-able-input').removeClass('no-week');
			}else if($("input[type='checkbox'][name^='flg_able_']:checked").length == 0){
				$('.js-reserve-able-input').addClass('no-week');
			}
		});

		//  ▼読み込んだ時
		var selectWeek = [];
		// チェックした曜日の予約可能時間を表示
		$("input[type='checkbox'][name^='flg_able_']:checked").each(function(){
			var name = $(this).attr('name');
			selectWeek.push(name);
		})
		$.each(selectWeek, function(index, value){
			if ($('#week-' + value).css('display') == 'flex') {
				$('#week-' + value).css('display', 'none');
				$('#week-' + value + ' .js-select-wrap .js-select2').removeAttr("required");
			} else {
				$('#week-' + value).css('display', 'flex');
				$('#week-' + value + ' .js-select-wrap .js-select2').prop("required", true);
			}
		});
		//チェック数0の時見出し非表示
		if(selectWeek.length === 0) {
			$('.js-reserve-able-input').addClass('no-week');
		}
	});



	$(function(){
		const datepickerCalendar = document.getElementById('js-datepicker');
		const datepickerValue = $('#temporary_businessdays');
		let datepickerAry = new Array;
		let datepickerAry2 = new Array;
		const datepickerValue2 = $('#temporary_holidays');
		const datepickerCalendar2 = document.getElementById('js-datepicker2');
		const $datepickerCalendar2 = $(datepickerCalendar2);
		const $datepickerCalendar = $(datepickerCalendar);
		var aSetDateBusiness = datepickerValue.val();
		if(datepickerValue.val()) {
			var aSetDateBusiness = aSetDateBusiness.split(',');
		}else{
			var aSetDateBusiness = "";
		}
		var aSetDateHoliday = datepickerValue2.val();
		if(datepickerValue2.val()) {
			var aSetDateHoliday = aSetDateHoliday.split(',');
		}else{
			var aSetDateHoliday = '';
		}

	// 読み込み時に臨時営業日と臨時休業日で重複した日付を削除
  // for (let i = 0; i <= aSetDateHoliday.length; i++) {
	// 	var index = aSetDateBusiness.indexOf(aSetDateHoliday[i]);
	// 	if(index != -1) {
	// 		aSetDateBusiness.splice(index, 1);
	// 	}
	// };
	// str = aSetDateBusiness.join(',');
	// // 臨時営業日のinput hiddenのvalueに挿入
	// datepickerValue.val(str);


		/*
		臨時営業日
		*/
		$datepickerCalendar .multiDatesPicker({
			monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
			monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
			dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
			dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
			dateFormat: 'yy/mm/dd',
			nextText: '次へ',
			prevText: '前へ',
			showOtherMonths: true,
			selectOtherMonths: true,
			firstDay: 0,
			isRTL: false,
			showMonthAfterYear: true,
			yearSuffix: '年',
			numberOfMonths: ($(window).width() > 767) ? 1 : 1,
			minDate: '+0d',
			maxDate: '+1y',
			changeYear: true,
			changeMonth: true,
			yearRange: 'c-1:c+1',
			addDates: aSetDateBusiness,
			// addDisabledDates: aSetDateHoliday,
			altField: temporary_businessdays,
			beforeShowDay: function(dateText) {
				// 臨時休業日と重複した日付に色を変えるクラスを付与
					var duplicateDate = $.datepicker.formatDate('yy/mm/dd', dateText);
					if((aSetDateBusiness.length && aSetDateHoliday.length) && aSetDateBusiness.indexOf(duplicateDate) !== -1 && aSetDateHoliday.indexOf(duplicateDate) !== -1) {
                return [true, "duplicate-date", duplicateDate];
            }
            else {
                return [true, '', ''];
            }
			},

		});

		/*
		臨時休業日
		*/
		$datepickerCalendar2.multiDatesPicker({
				monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
				monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
				dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
				dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
				dateFormat: 'yy/mm/dd',
				nextText: '次へ',
				prevText: '前へ',
				showOtherMonths: true,
				selectOtherMonths: true,
				firstDay: 0,
				isRTL: false,
				showMonthAfterYear: true,
				yearSuffix: '年',
				numberOfMonths: ($(window).width() > 767) ? 1 : 1,
				minDate: '+0d',
				maxDate: '+1y',
				changeYear: true,
				changeMonth: true,
				yearRange: 'c-1:c+1',
				addDates: aSetDateHoliday,
				altField: temporary_holidays,

		});
	});
	// $('.btn-submit-box button[type="button"]').on(oEventNames.end, function (event) {
  //   if (!bIsScrolling) {
  //     event.preventDefault();
	// 		const datepickerValue = $('#temporary_businessdays');
	// 		const datepickerValue2 = $('#temporary_holidays');
	// 			var aSetDateBusiness = datepickerValue.val();
	// 			var aSetDateHoliday = datepickerValue2.val();
	// 		if(datepickerValue.val()) {
	// 			var aSetDateBusiness = aSetDateBusiness.split(', ');
	// 		}else{
	// 			var aSetDateBusiness = [];
	// 		}
	// 		if(datepickerValue2.val()) {
	// 			var aSetDateHoliday = aSetDateHoliday.split(', ');
	// 		}else{
	// 			var aSetDateHoliday = [];
	// 		}
	// 		if(aSetDateBusiness.length && aSetDateHoliday.length) {
	// 			for (let i = 0; i <= aSetDateHoliday.length; i++) {
	// 				var index = aSetDateBusiness.indexOf(aSetDateHoliday[i]);
	// 				if(index != -1) {
	// 					aSetDateBusiness.splice(index, 1);
	// 				}
	// 			};
	// 			str = aSetDateBusiness.join(',');
	// 			// 臨時営業日のinput hiddenのvalueに挿入
	// 			datepickerValue.val(str);
	// 		}
	// 		$('#form_update').submit();
  //   }
  // });
};
